import {
    MenuItem,

    // Select
} from '@mui/material'
import cn from 'classnames'
import React from 'react'
import RangeDropDown from './rangedropdown/RangeDropDown'
import VolumeTypeSelection from './volumetypeselection/VolumeTypeSelection'
import { Select, SelectSection, SelectItem } from '@nextui-org/react'
import UserTypeSelection from './usertypeselection/UserTypeSelection'
const StatsElement = (props) => {
    const {
        children,
        onChange,
        className,
        selectVolumeType,
        volumeType,
        selectUserType,
        userType,
        currency,
        setCurrency,
        isLoading,
    } = props

    const currencyDropDownOptions = [
        { value: 'wax', label: 'WAX' },
        { value: 'usd', label: 'USD' },
    ]

    const selectCurrency = (e) => {
        setCurrency(e.target.value)
    }

    const getCurrencyOption = (search) => {
        return currencyDropDownOptions.map((item) => item.value).indexOf(search)
    }

    const defaultCurrencyOption =
        currencyDropDownOptions[getCurrencyOption(currency)]

    return (
        <div className={className}>
            <div className="flex flex-wrap items-center w-full gap-4 lg:justify-between">
                {selectVolumeType ? (
                    <div className="flex flex-wrap items-center justify-center lg:justify-between  my-auto">
                        <div className="flex flex-wrap justify-center">
                            <VolumeTypeSelection
                                selectVolumeType={selectVolumeType}
                                volumeType={volumeType}
                            />
                        </div>
                    </div>
                ) : selectUserType ? (
                    <div className="flex flex-wrap items-center justify-center lg:justify-between  my-auto">
                        <div className="flex flex-wrap justify-center">
                            <UserTypeSelection
                                userType={userType}
                                selectUserType={selectUserType}
                            />
                        </div>
                    </div>
                ) : (
                    ''
                )}
                <div className="flex flex-wrap items-center justify-center gap-4 md:flex-nowrap ">
                    <div>
                        <div className="min-w-[160px] ">
                            {onChange && <RangeDropDown {...props} />}
                        </div>
                    </div>
                    <div className="flex items-center ">
                        {setCurrency ? (
                            <div className=" min-w-[160px]">
                                <Select
                                    size="md"
                                    fullWidth
                                    placeholder="Select Currency"
                                    variant="faded"
                                    value={defaultCurrencyOption?.value}
                                    onChange={selectCurrency}
                                    disabled={isLoading}
                                >
                                    {currencyDropDownOptions.map((option) => (
                                        <SelectItem
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </Select>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            <div
                className={cn(
                    'w-full overflow-y-auto',
                    'flex flex-row rounded-m',
                    'justify-center items-center',
                )}
            >
                {children}
            </div>
        </div>
    )
}

export default StatsElement
